<template>
    <div>
        
        <el-dialog :close-on-click-modal="false" title="BUSCAR CARTÓRIO" width="70%" :visible.sync="dialogSearchCartorio" v-on:close="closeDialog">
            
            <el-row :gutter="10" class="u-mb-10 u-mt-10">                    
                <el-col :xs="24" :sm="24" :md="24">                        
                    <el-input key="c-nome" placeholder="Nome Cartório" v-model="filtros['nome']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                </el-col>
            </el-row>
            <el-row :gutter="10" class="u-mb-10 u-mt-10">                    
                <el-col :xs="24" :sm="18" :md="18">                        
                    <el-input key="c-cidade" placeholder="Cidade" v-model="filtros['cidade']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                </el-col>
                <el-col :xs="24" :sm="6" :md="6">                        
                    <el-input key="c-estado" placeholder="UF" v-model="filtros['estado']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                </el-col>
            </el-row>                 

            <div class="container-table" style="height: 295px;">
                <table class="table table-striped table--hover">
                    <thead>
                        <tr>
                            <th>Cartório</th>
                            <th class="hidden-mobile">Cidade</th>
                            <th class="hidden-mobile u-text-center">Estado</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loadingCartorio">
                        <tr v-for="cartorio in cartorios" :key="cartorio.id" @click="selectCartorio(cartorio)" class="u-pointer" style="user-select: none;">
                            <td>{{ cartorio['nome'] }}</td>
                            <td class="hidden-mobile">{{ cartorio['cidade']['nome'] }}</td>
                            <td class="hidden-mobile u-text-center">{{ cartorio['cidade']['estado']['nome'] }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr v-if="!loadingCartorio && cartorios.length == 0" style="border-top: 1px solid #ddd;">
                            <td colspan="100%" class="u-text-center">
                                <span>nenhum registro</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <div v-if="loadingCartorio" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <div class="footer-search">
                    <div>
                        <el-pagination :current-page="paginate.page" v-if="paginate.qtdCartorios > 9" :page-size="9" :total="paginate.qtdCartorios" @current-change="getPagePagination" background layout="prev, pager, next" small></el-pagination>
                    </div>
                    <div>
                        <el-button type="danger" @click="closeDialog">CANCELAR</el-button>
                        <el-button type="primary" @click="getCartorio">PESQUISAR</el-button>
                    </div>
                </div>
            </span>
        </el-dialog>
    </div>
</template>
<script>

export default {
    props: {
        open: {
            required: false,
            type: [Boolean],
            default: false
        },
    },
    data: () => ({
        paginate: {
            page: 1,
            qtdCartorios: null,
        },
        filtros:{
            nome: '',
            cidade: '',
            estado: ''
        },
        cartorios: [],
        dialogSearchCartorio: false,
        loadingCartorio: false,
        

    }),
    mounted(){ },
    methods:{
        selectCartorio(cartorio){

            this.$emit('emitCartorio', cartorio);
        },
        changeFiltros(){
            
            this.paginate.page = 1;
            this.getCartorio();
        },
        closeDialog(){

            this.$emit('close');

            this.filtros = {
                nome: '',
                cidade: '',
                estado: ''
            };

            this.cartorios = [];
        },
        getCartorio(){

            this.filtros.nome = this.$removerAcentos(this.filtros.nome);
            this.filtros.cidade = this.$removerAcentos(this.filtros.cidade);
            this.filtros.estado = this.$removerAcentos(this.filtros.estado);

            this.loadingCartorio = true;
            
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/cartorio/getByFiltrosPaginate` + '?page=' + this.paginate.page, this.filtros, this.$store.getters.getHeaderAuth).then(response => {
                
                this.cartorios = response.data.data;
                this.paginate.qtdCartorios = response.data.total;
                this.loadingCartorio = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.getCartorio();
        },

    },
    watch: {
        open: {
            immediate: true,
            handler (value) {

                this.dialogSearchCartorio = value;
            }
        },
    }
}
</script>
